/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LinkDirection {
	None = 0,
	AtoB = 1,
	BtoA = 2,
	Both = 3,
}
